import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isWithinWorkingHours(): boolean {
  const now = new Date()
  const day = now.getDay() // 0 is Sunday, 1-5 is Monday-Friday, 6 is Saturday
  const hours = now.getHours()
  const minutes = now.getMinutes()
  const currentTime = hours + minutes / 60

  // Check if it's a weekday (Monday-Friday)
  if (day >= 1 && day <= 5) {
    // Check if current time is between 9:00 (9.0) and 17:00 (17.0)
    return currentTime >= 9.0 && currentTime < 17.0
  }

  // Saturday and Sunday are closed
  return false
} 